import { render, staticRenderFns } from "./EvaluacionDocentePage.vue?vue&type=template&id=9252da38&scoped=true&"
import script from "./EvaluacionDocentePage.vue?vue&type=script&lang=js&"
export * from "./EvaluacionDocentePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9252da38",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/evaluacion-docente/EvaluacionDocentePage.vue
// module id = 203
// module chunks = 6